module.exports = function (cb, apiEndpoint) {

    var $searchRendering = $('.search-rendering');
    var endpointUrl = URI(/icfapi/ + apiEndpoint);
    var browserUrl = URI(window.location.toString());

    var contextItemId = $searchRendering.data('contextItemId');
    endpointUrl.setQuery('contextItemId', contextItemId);

    if (window.query && window.query.length) {
        endpointUrl.setQuery('q', window.query);
        browserUrl.setQuery('q', window.query);
    }

    if (window.types && window.types.length) {
        var joinedTypes = window.types.join('|');

        if (joinedTypes.length) {
            endpointUrl.setQuery('types', joinedTypes);
            browserUrl.setQuery('types', joinedTypes);
        }
    }
    else {
        browserUrl.removeQuery('types');
    }

    if (window.typecategories && window.typecategories.length) {
        var joinedTypeCategories = window.typecategories.join('|');

        if (joinedTypeCategories.length) {
            endpointUrl.setQuery('typecategories', joinedTypeCategories);
            browserUrl.setQuery('typecategories', joinedTypeCategories);
        }
    }
    else {
        browserUrl.removeQuery('typecategories');
    }

    if (window.topics && window.topics.length) {        
        var joinedTopics = window.topics.join('|');

        if (joinedTopics.length) {            
            endpointUrl.setQuery("topics", joinedTopics);
            browserUrl.setQuery('topics', joinedTopics);
        }
    }
    else {
        browserUrl.removeQuery('topics');
    }

    if (window.page > 1) {
        endpointUrl.setQuery('page', window.page);
        browserUrl.setQuery('page', window.page);
    }
    else {
        endpointUrl.removeQuery('page');
        browserUrl.removeQuery('page');
    }              
    
    history.replaceState({}, '', browserUrl.toString());

    $.ajax({
        url: endpointUrl.toString(),
        success: function (result) {
            if (cb) {
                cb(result);
            }
        }
    });
    
};